export default "__VITE_ASSET__CB$VPUtS__"